import { z } from "zod";

export const RelatedEntityKey = z.union([
  z.literal("assignment"),
  z.literal("worker"),
  z.literal("job-request"),
  z.literal("candidate"),
]);

export type RelatedEntityKey = z.infer<typeof RelatedEntityKey>;
